// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36TnM","question":"styles_question__AWDl2","inputVisibleButton":"styles_inputVisibleButton__22PWZ","note":"styles_note__5ki0t"};